import React from 'react';
import { Banknote } from 'lucide-react';
import { COUNTRIES, INVESTMENT_POLICIES } from '.';

export const defaultFundFounderQuestions = [
  {
    id: 'logo',
    placeholder: 'logo',
    title: 'uploadLogo',
    type: 'avatar',
    image: <Banknote size={60} className='file-icon' />,
    mandatory: false,
  },
  {
    id: 'name',
    title: 'name',
    placeholder: 'name',
    type: 'text',
    mandatory: true,
  },
  {

    id: 'lei',
    type: 'text',
    title: 'LEI',
    placeholder: 'LEI',
    mandatory: false,
  },
  {
    id: 'fundManager',
    type: 'text',
    title: 'fundManager',
    placeholder: 'fundManager',
    mandatory: false,
  },
  {
    id: 'country',
    mandatory: true,
    placeholder: 'country',
    title: 'country',
    type: 'select',
    answers: COUNTRIES,
    literals: 'countries',
  },
  {
    id: 'address',
    mandatory: false,
    placeholder: 'address',
    title: 'address',
    type: 'text',
  },
  {
    id: 'investmentPolicy',
    mandatory: false,
    placeholder: 'investmentPolicy',
    title: 'investmentPolicy',
    type: 'list',
    answers: INVESTMENT_POLICIES,

  },
  {
    id: 'institutionType',
    mandatory: false,
    placeholder: 'institutionType',
    title: 'institutionType',
    type: 'select',
    answers: ['opened', 'closed'],
    literals: 'institutionType',
  },
  {
    id: 'subfund',
    mandatory: false,
    placeholder: 'subfund',
    title: 'subfund',
    type: 'select',
    answers: [true, false],
  },
  {
    id: 'isin',
    mandatory: false,
    placeholder: 'ISIN',
    title: 'ISIN',
    type: 'multiValue',
  },
  {
    id: 'managementCountry',
    mandatory: false,
    placeholder: 'managementCompanyCountry',
    title: 'managementCompanyCountry',
    type: 'select',
    answers: COUNTRIES,
    literals: 'countries',
  },
  {
    id: 'managementAddress',
    mandatory: false,
    placeholder: 'managementCompanyAddress',
    title: 'managementCompanyAddress',
    type: 'text',
  },
  {
    id: 'regulator',
    mandatory: false,
    placeholder: 'fundRegulator',
    title: 'fundRegulator',
    type: 'text',
  },
];
